"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ConfirmClassConfigurationSaveDialogModule = /** @class */ (function () {
    function ConfirmClassConfigurationSaveDialogModule() {
    }
    return ConfirmClassConfigurationSaveDialogModule;
}());
exports.ConfirmClassConfigurationSaveDialogModule = ConfirmClassConfigurationSaveDialogModule;
